import { Component, ViewContainerRef } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MbCheckoutStepService } from '../../../services/mb-checkout-step.service'
import {
  EventService,
  GlobalMessageService,
  SemanticPathService,
  TranslationService,
  UserIdService
} from '@spartacus/core'
import { CmsComponentData, LaunchDialogService } from '@spartacus/storefront'
import { MbCheckoutReviewNotesConnector } from '../../../connectors/review-notes'
import { MbCheckoutReviewBaseComponent } from '../mb-checkout-review-base.component'
import { MbCheckoutNavigationService } from '../../../services/mb-checkout-navigation.service'
import { MbOrderFacade } from '../../../facades/mb-order.facade'
import { MbCheckoutRegions } from '../../../../models'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade
} from '@spartacus/checkout/base/root'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { OrderFacade } from '@spartacus/order/root'

@Component({
  selector: 'mb-checkout-review-un',
  templateUrl: './mb-checkout-review-un.component.html',
  styleUrls: ['../mb-checkout-review-base.component.scss']
})
export class MbCheckoutReviewUnComponent extends MbCheckoutReviewBaseComponent {

  checkoutRegion = MbCheckoutRegions.UN

  constructor (protected activatedRoute: ActivatedRoute,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected router: Router,
               protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
               protected checkoutPaymentService: CheckoutPaymentFacade,
               protected activeCartService: ActiveCartFacade,
               protected translation: TranslationService,
               protected checkoutStepService: CheckoutStepService,
               protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
               protected launchDialogService: LaunchDialogService,
               protected vcr: ViewContainerRef,
               protected checkoutReviewNotesConnector: MbCheckoutReviewNotesConnector,
               public component: CmsComponentData<any>,
               protected mbCheckoutNavigationService: MbCheckoutNavigationService,
               protected globalMessageService: GlobalMessageService,
               protected mbCheckoutService: MbOrderFacade,
               protected userIdService: UserIdService,
               protected semanticPathService: SemanticPathService,
               protected orderFacade: OrderFacade,
               protected eventService: EventService) {
    super(activatedRoute, mbCheckoutStepService, router, checkoutDeliveryAddressFacade, checkoutPaymentService,
      activeCartService, translation, checkoutStepService, checkoutDeliveryModesFacade, launchDialogService, vcr,
      checkoutReviewNotesConnector, component, mbCheckoutNavigationService,
      globalMessageService, mbCheckoutService, userIdService, semanticPathService, orderFacade, eventService)
  }
}
